import React from 'react';
import { memo } from 'react';

import { KnobProps } from 'components/atoms/Knob/Knob';
import withSequenceState from 'components/hoc/withSequenceState';
import Button from 'components/molecules/Button';
import Sequences from 'defs/sequences';
import { generateClassNameString } from 'helper/css';
import noop from 'helper/noop';

export type CardLikeProps = {
	onClick: () => any;
	modifier?: string | string[];
	isSequenceLoading?: boolean;
	liked?: boolean;
};

export const CardLike = ({ liked = false, onClick = noop, isSequenceLoading = false, modifier }: CardLikeProps) => {
	const knopProps: KnobProps = {
		type: liked ? 'like' : '',
		modifier: 'transparent',
		size: 'l',
		icon: 'heart',
		loading: isSequenceLoading,
	};

	if (modifier === 'product') {
		knopProps.modifier = 'solid';
		knopProps.size = 'm';
	}

	return (
		<div className={generateClassNameString('m-card__like', modifier)}>
			<Button
				handleButtonClick={
					/* istanbul ignore next */
					() => onClick()
				}
				knob={knopProps}
			/>
		</div>
	);
};

CardLike.displayName = 'Card(Like)';

export default (withSequenceState(memo(CardLike), [Sequences.FAVORITE_IS_TOGGLING]) as any) as React.ComponentType<
	CardLikeProps
>;
